import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { DashboardBottomNav } from "@/components/dashboard/DashboardBottomNav";
import {
	DashboardProvider,
	useDashboardContext,
} from "@/components/dashboard/DashboardContext";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { Header } from "@/components/Header";
import { LoadingScreen } from "@/components/LoadingScreen";
import { useSession } from "@/hooks/auth-hooks";

export const Route = createFileRoute("/dashboard")({
	component: DashboardLayoutRoute,
});

function DashboardLayoutRoute() {
	const navigate = useNavigate();
	const { user, isPending } = useSession();

	useEffect(() => {
		if (isPending) return;
		if (!user) {
			navigate({ to: "/signup", replace: true });
		}
	}, [user, isPending, navigate]);

	if (isPending || !user) {
		return <LoadingScreen />;
	}

	return (
		<DashboardProvider>
			<McpGate>
				<DashboardSidebar />
				<div className="relative min-h-svh md:ml-64" style={{ backgroundColor: "var(--km-surface)", color: "var(--km-on-surface)" }}>
					<Header />
					<Outlet />
					<DashboardBottomNav />
				</div>
			</McpGate>
		</DashboardProvider>
	);
}

function McpGate({ children }: { children: React.ReactNode }) {
	const navigate = useNavigate();
	const { isMcpConnected, isMcpLoading } = useDashboardContext();

	useEffect(() => {
		if (isMcpLoading) return;
		if (!isMcpConnected) {
			navigate({ to: "/setup", replace: true });
		}
	}, [isMcpConnected, isMcpLoading, navigate]);

	if (isMcpLoading) {
		return <LoadingScreen />;
	}

	if (!isMcpConnected) {
		return null;
	}

	return <>{children}</>;
}
